import { toTitleCase } from "../../util/toTitleCase";

export default function SidebarButton({ title, onClick, selected }) {

  const classNames = () => {
    let classes = "text-sm w-full py-2 cursor-pointer active:scale-95 transition-all duration-200 ease-in-out text-stone-200 text-center rounded-md ";
    if (selected?.toLowerCase() === title?.toLowerCase()) classes += "bg-yellow-600 hover:bg-yellow-800 font-semibold";
    else classes += "hover:bg-stone-700";
    return classes;
  };

  return (
    <div className={classNames()} onClick={onClick}>
      <p className="">{toTitleCase(title)}</p>
    </div>
  );
}
